module.exports = __webpack_public_path__ + "static/img/icon-wuxijisai@2x.476ec53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-wuxijisai@2x.png
// module id = 370
// module chunks = 0